import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  errorNotoTitle: {
    description: 'labelQue.errorNotoTitle',
    defaultMessage: 'Label Queue Error',
    id: '1dreRH',
  },
  errorNotoBody: {
    description: 'labelQue.errorNotoBody',
    defaultMessage: 'An error occurred while processing a request from the Label Queue. Please try again.',
    id: '8mm3Dy',
  },
  errorCreatingOrderSummary: {
    description: 'printErrors.errorCreatingOrderSummary',
    defaultMessage: 'Error Creating Order Summary',
    id: 'vneGHO',
  },
  unknownError: {
    description: 'printErrors.unknownError',
    defaultMessage: 'Unknown Error',
    id: 'IIBnIE',
  },
});
